'use client';
import { useCallback, useEffect, useRef } from 'react';
import { ReactLenis } from 'lenis/react';
import { useStore } from '@/store/main';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

const Template = ({ children }) => {
  const [isMenuOpen, isPopupOpen] = useStore((state) => [state.isMenuOpen, state.isPopupOpen]);
  const lenisRef = useRef();
  const rafRef = useRef();

  useEffect(() => {
    function update(time) {
      lenisRef.current?.lenis?.raf(time * 1000);
    }

    rafRef.current = update;
    gsap.ticker.add(update);
    gsap.ticker.lagSmoothing(0);

    return () => {
      gsap.ticker.remove(update);
    };
  }, []);

  const onLenisRef = useCallback((ref) => {
    lenisRef.current = ref;
    const lenis = ref?.lenis;
    if (lenis) {
      lenis.on('scroll', ScrollTrigger.update);
      ScrollTrigger.refresh();
    }
  }, []);

  useEffect(() => {
    const onScroll = () => ScrollTrigger.update();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (isMenuOpen || isPopupOpen) {
      lenisRef.current?.lenis?.stop();
    } else {
      lenisRef.current?.lenis?.start();
    }
  }, [isMenuOpen, isPopupOpen]);

  return (
    <ReactLenis ref={onLenisRef} root autoRaf={false}>
      {children}
    </ReactLenis>
  );
};

export default Template;
